import { getMolecule, type MoleculeResponse } from '@peruselab/api-client/molecules';

// One in-flight promise per molecule id, memoised module-wide, so the same molecule appearing
// in a search-result thumbnail and in that card's name (ADR 0007 P6d) -- or across several
// result groups -- is fetched once. A rejected attempt is evicted so a later use can retry.
const cache = new Map<string, Promise<MoleculeResponse>>();

export function fetchMolecule(id: string): Promise<MoleculeResponse> {
  const cached = cache.get(id);
  if (cached) return cached;
  const pending = getMolecule(id);
  pending.catch(() => cache.delete(id));
  cache.set(id, pending);
  return pending;
}
